const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiFetch = async (
  
  endpoint,
  {
    method = "GET",
    body = null,
    headers = {},
    signal,
  } = {}
) => {
  const isFormData =
    typeof FormData !== "undefined" && body instanceof FormData;
  const configHeaders = {
    ...headers,
  };

  if (!isFormData && !configHeaders["Content-Type"]) {
    configHeaders["Content-Type"] = "application/json";
  }

  const config = {
    method,
    credentials: "include",
    headers: configHeaders,
    signal,
  };

  if (body !== null) {
    config.body = isFormData ? body : JSON.stringify(body);
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, config);

  if (!response.ok) {
    let message = "Request failed";

    try {
      const data = await response.json();
      if (data) {
        if (typeof data.message === "string" && data.message.trim()) {
          message = data.message;
        } else if (typeof data.error === "string" && data.error.trim()) {
          message = data.error;
        } else if (typeof data.detail === "string" && data.detail.trim()) {
          message = data.detail;
        } else if (typeof data === "object") {
          const firstFieldError = Object.values(data).find(
            (value) =>
              typeof value === "string" ||
              (Array.isArray(value) && value.length > 0)
          );

          if (typeof firstFieldError === "string" && firstFieldError.trim()) {
            message = firstFieldError;
          } else if (Array.isArray(firstFieldError) && firstFieldError.length > 0) {
            message = String(firstFieldError[0]);
          }
        }
      }
    } catch {
      // ignore parsing errors
    }

    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};
